var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"advtisement",on:{"click":function($event){return _vm.goDatails(_vm.url)}}},[_c('div',[_c('img',{attrs:{"src":_vm.imgSrc,"alt":"广告图"}})]),_c('div',[_vm._v(_vm._s(_vm.des))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }